var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartFinderNoAttributes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 166,
    viewBox: "0 0 194 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECT"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.52962 40.8158C0.895789 41.0729 -0.220267 42.6057 0.0368393 44.24L12.3909 122.734C12.648 124.368 14.1808 125.484 15.8151 125.227L72.9808 116.229C74.6147 115.972 75.7307 114.439 75.4736 112.805L65.1546 47.2412L46.1679 33.9473L2.52962 40.8158Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50.6062 49.5316L65.1576 47.2412L46.1709 33.9473L48.367 47.9018C48.5356 48.9702 49.5377 49.6997 50.6062 49.5316Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M46.1709 33.9473L48.367 47.9018C48.5351 48.9702 49.5373 49.6997 50.6058 49.5316L65.1572 47.2412",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.0982 87.1621C33.7837 85.1626 33.6827 83.5279 33.7957 82.2597C33.9087 80.9915 34.3255 79.7798 35.047 78.6242C35.4593 77.9338 35.9526 77.3182 36.5278 76.776C37.1021 76.2346 37.6216 75.675 38.0873 75.0977C38.5517 74.5216 38.9227 73.898 39.1998 73.229C39.4765 72.56 39.5379 71.7348 39.3831 70.7513C39.122 69.0912 38.4814 68.0014 37.4619 67.4845C36.4428 66.9677 35.3054 66.808 34.0519 67.005C32.2548 67.2879 31.0965 67.9832 30.5765 69.089C30.0556 70.1962 29.8439 71.6098 29.9413 73.3313L23.3829 74.3637C23.1213 72.7032 23.1547 71.1521 23.4839 69.7104C23.8126 68.2697 24.4024 66.9957 25.2529 65.889C26.103 64.7831 27.1919 63.8646 28.5188 63.1346C29.8448 62.4051 31.3559 61.9065 33.0511 61.6396C36.7115 61.0636 39.7185 61.3545 42.072 62.5123C44.4247 63.6711 45.8659 65.9272 46.3939 69.283C46.5647 70.3683 46.6034 71.334 46.5118 72.1823C46.4188 73.0306 46.2044 73.8197 45.8686 74.5501C45.5314 75.2805 45.0866 75.9846 44.5337 76.6621C43.9799 77.34 43.3451 78.0477 42.6276 78.7857C41.9724 79.4796 41.4551 80.1086 41.0743 80.6713C40.694 81.2349 40.4275 81.8069 40.2763 82.3861C40.1242 82.9661 40.061 83.5582 40.0868 84.1613C40.1122 84.7654 40.1842 85.4406 40.3012 86.1857L34.0982 87.1621ZM35.4398 97.0069L34.3913 90.3466L41.2549 89.2661L42.3033 95.9264L35.4398 97.0069Z",
    fill: "#D6D6D6"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M67.6807 91.1016C75.248 98.5394 84.0492 108.576 92.2277 121.544C97.9174 130.565 102.136 139.149 105.283 146.703C98.0299 149.967 90.7771 153.231 83.5239 156.495L64.877 93.0388L67.6807 91.1016Z",
    fill: "#FEC02D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M53.9343 85.9717L67.8844 90.3318C71.7067 96.3938 73.9144 101.764 75.2101 105.498C81.2459 122.89 79.31 138.807 78.7629 143.305C78.7629 143.305 78.7536 143.382 76.9947 156.497H13.2123C13.001 151.743 13.0419 145.169 14.1642 137.457C15.4951 128.313 16.7308 119.824 22.2626 110.5C24.5121 106.709 32.3392 94.5776 47.347 88.2269C50.0239 87.094 52.3383 86.3951 53.9343 85.9717Z",
    fill: "#FEC02D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M21.1187 112.529C28.8835 115.02 38.7714 117.465 50.3915 118.656C61.2162 119.765 70.758 119.501 78.4917 118.775C78.7132 120.599 78.9352 122.423 79.1572 124.248C70.8977 124.921 61.0756 125.124 50.0859 124.164C37.7746 123.087 27.1091 120.821 18.4453 118.388C19.3363 116.435 20.2273 114.483 21.1187 112.529Z",
    fill: "#FF7129"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.5,
    d: "M80.9765 107.65L84.1361 108.355L72.6317 156.498H66.1182L80.9765 107.65Z",
    fill: "#E8A600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M55.1638 147.279L57.8697 146.437L64.0714 149.643L65.6354 145.85L57.7647 142.823L54.5518 144.329L55.1638 147.279Z",
    fill: "#E8A600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.5,
    d: "M13.1123 149.289C19.4354 150.87 26.9943 152.284 35.5829 152.97C43.1124 153.572 49.9235 153.493 55.808 153.097C55.808 150.68 55.808 148.263 55.808 145.846C41.7712 144.278 27.734 142.71 13.6972 141.142L13.1123 149.289Z",
    fill: "#E8A600"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M59.5716 95.9921C55.6274 95.316 52.978 91.5706 53.6542 87.6264L56.2888 72.2578L70.5721 74.7065L67.9374 90.0751C67.2617 94.0189 63.5158 96.6682 59.5716 95.9921Z",
    fill: "#F7A99C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M68.6734 85.7682L60.2147 79.3623C60.168 80.1839 60.035 84.0467 62.8943 87.2321C64.7199 89.2658 66.8781 90.0358 67.887 90.3236L68.6734 85.7682Z",
    fill: "#FF7769"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M56.7751 67.4362C56.7706 67.1965 56.2208 66.7388 56.054 66.5857C55.7724 66.3273 55.4571 66.1049 55.119 65.9265C54.462 65.5804 53.7058 65.3941 52.9612 65.4328C51.4808 65.5093 50.0098 66.4839 49.516 67.9069C49.2291 68.7333 49.2714 69.6479 49.4991 70.4926C49.8412 71.7626 50.5978 72.9124 51.6071 73.7558C52.4434 74.4551 53.4491 74.9439 54.5082 75.1953C54.7204 75.2455 56.9227 75.5791 56.921 75.4924C56.8725 72.807 56.8235 70.1216 56.7751 67.4362Z",
    fill: "#F7A99C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M54.7899 67.2429C54.7578 68.4186 54.7053 74.6389 59.4044 79.8647C60.2701 80.8273 66.0252 87.2269 72.5769 85.7452C80.996 83.8409 82.3999 70.8068 82.4666 70.0995C82.6935 67.7077 83.3612 60.664 78.2573 55.948C74.092 52.0994 68.8084 52.3196 68.0575 52.3627C67.2658 52.4081 62.2072 52.7809 58.4103 57.0107C54.9642 60.8495 54.8424 65.319 54.7899 67.2429Z",
    fill: "#F7A99C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M78.0144 69.328C77.9646 70.356 78.6118 71.2229 79.4605 71.2643C80.3092 71.3057 81.0379 70.5059 81.0877 69.4779C81.1379 68.4499 80.4903 67.5829 79.6416 67.5416C78.7929 67.5002 78.0642 68.3 78.0144 69.328Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M75.0147 70.3584L76.0751 72.4789C76.27 72.8685 76.0885 73.3418 75.6824 73.5006L74.2705 74.0535",
    stroke: "#262626",
    strokeWidth: 1.7049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M64.8804 73.0823C64.8244 74.2357 65.714 75.2165 66.8675 75.2726C68.0209 75.3286 69.0017 74.439 69.0578 73.2856C69.1138 72.1322 68.2242 71.1513 67.0707 71.0953C65.9173 71.0392 64.9365 71.9289 64.8804 73.0823Z",
    fill: "#FF7769"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M54.9087 72.4316C54.955 72.2066 55.2432 70.6773 54.2072 69.3562C53.3959 68.3211 52.2852 68.068 51.9805 68.0088",
    stroke: "#262626",
    strokeWidth: 1.7049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M54.2766 69.6847C54.2099 69.662 53.4061 69.4031 52.7211 69.9253C52.1579 70.3546 52.0899 70.996 52.0801 71.1027",
    stroke: "#262626",
    strokeWidth: 1.7049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M80.9389 72.5397C81.3379 72.5592 81.7013 72.6949 82.0091 72.9044C81.7756 74.0031 81.434 75.3256 80.9416 76.7063C80.8726 76.7099 80.8059 76.7205 80.7356 76.717C79.5822 76.6609 78.6926 75.6801 78.7486 74.5267C78.8047 73.3728 79.7855 72.4832 80.9389 72.5397Z",
    fill: "#FF7769"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M69.8079 67.1191L71.5484 69.0941L69.0557 69.9722",
    stroke: "#262626",
    strokeWidth: 1.7049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M69.0557 78.2564L75.3223 78.9704C75.3054 78.8423 75.0309 76.9914 73.5435 76.3184C72.0853 75.6587 70.0307 76.3891 69.0557 78.2564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M54.8552 65.8029C55.2004 65.9373 56.0144 66.3069 56.6621 67.1774C57.2586 67.9799 57.4018 68.7881 57.4441 69.1578C63.9438 68.5408 67.6959 66.7144 69.9556 65.0699C69.9556 65.0699 70.1206 64.9498 74.8855 61.3298C75.6533 62.1576 76.8556 63.2674 78.5575 64.2198C80.1006 65.0832 81.5289 65.524 82.5751 65.7602C85.9909 64.9653 88.3725 62.4134 88.4517 59.7489C88.5349 56.9425 86.0403 54.8181 84.2699 53.9351C81.3808 52.4943 80.0517 54.1753 75.8156 53.0655C72.4012 52.1709 72.5289 50.8858 69.327 50.1101C68.3595 49.8757 64.3397 48.9015 60.3003 51.0282C56.8934 52.8222 54.1942 56.4417 53.9255 60.6159C53.7779 62.9 54.3975 64.7425 54.8552 65.8029Z",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M53.9375 85.9717C48.2055 87.2786 37.4831 90.5796 27.4951 99.5143C27.4951 99.5143 17.4288 108.519 10.5634 125.218C9.95536 126.697 9.27478 128.259 8.52348 131.541C7.94121 134.086 7.67876 136.433 7.59291 138.482C7.52886 140.014 8.47277 141.408 9.91354 141.931C11.1795 142.39 12.6367 142.903 14.2523 143.441C17.2446 144.439 23.8818 147.158 31.4002 148.201C47.0783 150.377 55.7822 150.921 55.7822 150.921L56.9218 123.858L36.1985 121.235L53.9375 85.9717Z",
    fill: "#FEC02D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M70.6836 99.8916C73.2867 108.995 74.8996 116.617 75.92 122.174",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    opacity: 0.5,
    d: "M43.572 98.2578L31.9443 124.452H38.9818L43.572 98.2578Z",
    fill: "#E8A600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M82.6241 108.113L76.3438 106.334L62.6361 154.713L68.9165 156.492L82.6241 108.113Z",
    fill: "#4450E4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M56.469 130.232C56.469 130.232 68.2527 129.058 69.5089 129.446C70.7651 129.833 75.0647 132.267 75.6723 132.962C76.28 133.656 76.497 134.307 76.4103 134.958C76.3236 135.61 75.4553 136.347 75.4553 136.347C76.1354 137.407 76.159 138.133 76.014 138.623C75.7551 139.5 74.7267 140.415 74.7173 140.427C74.7934 140.698 74.8788 141.087 74.9019 141.561C74.9242 142.011 74.9686 142.916 74.5216 143.743C73.8579 144.97 72.4919 145.32 72.1929 145.39C72.1929 145.39 72.721 146.373 72.0266 147.198C71.3322 148.023 69.2487 149.064 66.7746 148.717C64.3005 148.37 57.8764 145.201 57.8764 145.201L55.8115 145.848L56.469 130.232Z",
    fill: "#F7A99C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    opacity: 0.5,
    d: "M88.65 107.648C104.484 107.648 117.32 94.8114 117.32 78.9771C117.32 63.1429 104.484 50.3066 88.65 50.3066C72.8157 50.3066 59.9795 63.1429 59.9795 78.9771C59.9795 94.8114 72.8157 107.648 88.65 107.648Z",
    fill: "#CDEBF5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M88.6532 46.5791C70.7611 46.5791 56.2568 61.0834 56.2568 78.9754C56.2568 96.8675 70.7611 111.372 88.6532 111.372C106.545 111.372 121.049 96.8675 121.049 78.9754C121.049 61.0834 106.545 46.5791 88.6532 46.5791ZM88.6532 106.082C73.6827 106.082 61.5466 93.9459 61.5466 78.9754C61.5466 64.005 73.6827 51.8689 88.6532 51.8689C103.624 51.8689 115.76 64.005 115.76 78.9754C115.76 93.9459 103.624 106.082 88.6532 106.082Z",
    fill: "#4450E4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M75.4501 136.348C75.4501 136.348 71.1105 135.539 68.9179 134.519C66.725 133.499 65.9092 132.938 65.9092 132.938",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M74.716 140.427C74.716 140.427 69.6864 139.924 67.6464 138.751C65.6065 137.578 64.877 136.812 64.877 136.812",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M73.0588 145.082C70.9049 144.998 69.2867 144.517 68.1577 144.054C66.2761 143.282 63.9248 141.81 63.9248 141.81",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M56.469 130.231L55.8115 145.847L57.8764 145.201L57.2145 130.158L56.469 130.231Z",
    fill: "#FF7769"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M42.7574 99.8916C42.7574 99.8916 31.9478 123.657 32.253 124.269C32.5577 124.881 56.9187 123.861 56.9187 123.861L55.7791 150.925C55.7791 150.925 36.7585 149.722 29.234 147.855C21.7094 145.988 13.1123 143.061 13.1123 143.061",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M90.1326 59.7811C89.9649 60.1548 89.9391 60.592 90.0944 61.0057C90.4066 61.8384 91.335 62.2601 92.1672 61.9479C93.6801 61.3803 95.3188 61.141 96.9055 61.2562C98.679 61.3847 100.037 61.9176 100.689 62.2237C101.462 62.5871 103.07 63.3433 104.269 64.9936C105.939 67.2919 105.799 69.9813 105.662 71.0311C105.546 71.9127 106.168 72.721 107.049 72.8366C107.931 72.9523 108.74 72.33 108.855 71.4492C109.088 69.6704 109.14 66.2199 106.874 63.1008C105.189 60.7807 102.995 59.7496 102.058 59.3092C101.015 58.819 99.3151 58.202 97.1377 58.0441C95.0906 57.896 92.9804 58.2029 91.0356 58.9329C90.617 59.0899 90.3021 59.403 90.1326 59.7811Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M33.7471 97.4717C29.8157 100.967 24.7666 106.187 20.1578 113.419C15.4258 120.845 12.8049 127.808 11.3076 132.932",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M109.908 156.504H61.765C59.8874 156.504 58.3652 154.981 58.3652 153.104V150.928H109.908V156.504H109.908Z",
    fill: "#2A83C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M145.82 156.502H93.2968C91.2341 156.502 89.7662 154.739 90.0184 152.564L93.988 118.315C94.2402 116.14 96.1165 114.377 98.1791 114.377H150.702C152.765 114.377 154.233 116.14 153.981 118.315L150.011 152.564C149.759 154.739 147.883 156.502 145.82 156.502Z",
    fill: "#2A83C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M150.888 156.502H98.3651C96.3025 156.502 94.8346 154.739 95.0868 152.564L99.0564 118.315C99.3086 116.14 101.185 114.377 103.247 114.377H155.771C157.833 114.377 159.301 116.14 159.049 118.315L155.079 152.564C154.828 154.739 152.951 156.502 150.888 156.502Z",
    fill: "#3897E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M159.051 120.283L155.082 152.766C155.082 152.766 155.259 156.501 149.14 156.501C143.02 156.501 114.767 156.501 114.767 156.501C118.467 156.477 131.424 155.944 143.326 146.199C155.204 136.474 158.293 123.91 159.051 120.283Z",
    fill: "#5FBBFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M157.964 124.456C156.774 128.306 153.884 135.845 146.959 142.886C140.126 149.832 132.755 152.848 128.938 154.118",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M127.08 138.87H125.244L126.414 131.424H128.25L127.08 138.87Z",
    fill: "#FEC02D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M129.495 138.868H127.659L128.466 133.734H130.302L129.495 138.868Z",
    fill: "#FEC02D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M75.7671 51.1592C73.1178 52.6542 66.4268 56.8911 62.0368 65.4375C57.6589 73.9598 58.0984 81.8434 58.4227 84.8699",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M79.01 141.4L77.9775 134.117",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M180.837 134.128H112.021C110.444 134.128 109.166 132.85 109.166 131.273V80.8924C109.166 79.3155 110.444 78.0371 112.021 78.0371H180.836C182.413 78.0371 183.692 79.3155 183.692 80.8924V131.273C183.692 132.85 182.414 134.128 180.837 134.128Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    opacity: 0.5,
    d: "M183.692 84.5266V80.8924C183.692 79.3155 182.414 78.0371 180.837 78.0371H112.021C110.444 78.0371 109.166 79.3155 109.166 80.8924V84.5266H183.692Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M113.037 81.6251C113.037 82.1135 112.641 82.5089 112.153 82.5089C111.665 82.5089 111.27 82.113 111.27 81.6251C111.27 81.1371 111.665 80.7412 112.153 80.7412C112.641 80.7408 113.037 81.1367 113.037 81.6251Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M115.836 81.6251C115.836 82.1135 115.44 82.5089 114.952 82.5089C114.464 82.5089 114.068 82.113 114.068 81.6251C114.068 81.1371 114.464 80.7412 114.952 80.7412C115.44 80.7408 115.836 81.1367 115.836 81.6251Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M118.693 81.6251C118.693 82.1135 118.297 82.5089 117.809 82.5089C117.32 82.5089 116.925 82.113 116.925 81.6251C116.925 81.1371 117.321 80.7412 117.809 80.7412C118.297 80.7408 118.693 81.1367 118.693 81.6251Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    opacity: 0.5,
    d: "M154.481 97.8584V94.2216C154.481 93.0286 153.514 92.0615 152.321 92.0615H131.21C130.017 92.0615 129.05 93.0286 129.05 94.2216V97.8584V122.087C129.05 123.28 130.017 124.247 131.21 124.247H164.969C166.162 124.247 167.129 123.28 167.129 122.087V100.018C167.129 98.8255 166.162 97.8584 164.969 97.8584H154.481Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M152.342 102.937L148.089 107.19L143.836 102.937L141.27 105.503L145.523 109.756L141.27 114.009L143.836 116.576L148.089 112.323L152.342 116.576L154.909 114.009L150.656 109.756L154.909 105.503L152.342 102.937Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M112.018 78.0371H180.833C182.41 78.0371 183.688 79.3155 183.688 80.8924V131.273",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M189.261 165.981H4.74375C2.12508 165.981 0.00195312 163.858 0.00195312 161.239C0.00195312 158.62 2.12508 156.497 4.74375 156.497H189.262C191.88 156.497 194.004 158.62 194.004 161.239C194.003 163.858 191.88 165.981 189.261 165.981Z",
    fill: "#FDB6D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M177.205 91.0142C176.878 88.4102 176.813 86.288 177.011 84.6493C177.209 83.0105 177.798 81.4568 178.78 79.9884C179.342 79.1108 180.007 78.3328 180.773 77.6531C181.539 76.9748 182.236 76.2706 182.862 75.5411C183.487 74.8129 183.993 74.0203 184.38 73.1644C184.765 72.309 184.878 71.2415 184.717 69.9608C184.446 67.7986 183.66 66.3609 182.36 65.6496C181.059 64.9384 179.592 64.6857 177.96 64.8908C175.62 65.1848 174.09 66.0388 173.372 67.4511C172.652 68.8648 172.32 70.6886 172.377 72.9233L163.836 73.9958C163.564 71.8335 163.67 69.8243 164.155 67.9698C164.639 66.1162 165.455 64.4886 166.602 63.0888C167.749 61.6898 169.197 60.5435 170.946 59.6512C172.694 58.7593 174.672 58.1744 176.88 57.8973C181.647 57.2986 185.532 57.7976 188.535 59.3928C191.537 60.9892 193.314 63.9713 193.863 68.3417C194.04 69.7549 194.051 71.0084 193.898 72.1035C193.744 73.1991 193.433 74.2133 192.969 75.1461C192.502 76.0789 191.897 76.9734 191.153 77.8288C190.408 78.6851 189.557 79.5761 188.597 80.504C187.72 81.3772 187.024 82.1707 186.509 82.8851C185.993 83.6004 185.624 84.3308 185.405 85.075C185.184 85.8205 185.079 86.5851 185.087 87.368C185.095 88.1522 185.162 89.0299 185.283 90L177.205 91.0142ZM178.545 103.827L177.456 95.1528L186.395 94.0305L187.484 102.705L178.545 103.827Z",
    fill: "#F5C411"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M156.319 48.5258C165.253 39.5925 165.253 25.1087 156.319 16.1754C147.386 7.24212 132.902 7.24211 123.969 16.1754C115.036 25.1087 115.036 39.5925 123.969 48.5258C132.902 57.4591 147.386 57.4591 156.319 48.5258Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    opacity: 0.5,
    d: "M153.268 45.4767C160.517 38.2273 160.517 26.4738 153.268 19.2245C146.019 11.9752 134.265 11.9752 127.016 19.2245C119.766 26.4738 119.766 38.2273 127.016 45.4767C134.265 52.726 146.019 52.726 153.268 45.4767Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M140.756 19.2832H139.532V34.388H140.756V19.2832Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M140.144 33.2651L139.532 34.3252L148.007 39.2185L148.619 38.1583L140.144 33.2651Z",
    fill: "#D6D6D6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartFinderNoAttributes);
export default __webpack_public_path__ + "static/media/partFinderNoAttributes.b9261379b812e04359f2665d867b6a00.svg";
export { ForwardRef as ReactComponent };